export default __webpack_public_path__ + "static/assets/f3eced34b594951ace5f3d3a8b9830c7.png";